var _linearGradient, _linearGradient2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMathematics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.079 512.079",
    height: 512,
    viewBox: "0 0 512.079 512.079",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.04,
    x2: 256.04,
    y1: 451.986,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe59a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffd5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.04,
    x2: 256.04,
    y1: 512.079,
    y2: 29.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m91.04 90.986v210h330v-210zm315 240h-300c-8.401 0-15 6.599-15 15v61c0 8.399 6.599 15 15 15h27.299l9.031 30 21.269-30h184.801l21.269 30 9.031-30h27.299c8.401 0 15-6.601 15-15v-61c.001-8.401-6.598-15-14.999-15zm-101.133-284.14c.952 7.588 7.412 13.14 14.868 13.14.615 0 1.245-.044 1.875-.117 8.218-1.025 14.048-8.525 13.022-16.743l-3.75-30c-1.025-8.218-8.555-13.975-16.743-13.022-8.218 1.025-14.048 8.525-13.022 16.743zm-114.478 13.023c.63.073 1.26.117 1.875.117 7.456 0 13.916-5.552 14.868-13.14l3.75-30c1.025-8.218-4.805-15.718-13.022-16.743-8.335-.952-15.703 4.805-16.743 13.022l-3.75 30c-1.025 8.218 4.805 15.718 13.022 16.744z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497.04 29.986h-482c-8.401 0-15 6.599-15 15v301c0 8.399 6.599 15 15 15h482c8.401 0 15-6.601 15-15v-301c0-8.401-6.599-15-15-15zm-170.501 215.499c6 5.7 6 15.3 0 21-5.396 6-15.6 6.002-20.999 0l-19.501-19.2-19.501 19.2c-5.396 6-15.6 6.002-20.999 0-6-5.7-6-15.3 0-21l19.199-19.499-19.199-19.501c-6-5.7-6-15.3 0-21 5.7-5.999 15.298-5.999 20.999 0l19.501 19.2 19.501-19.2c5.7-5.999 15.298-5.999 20.999 0 6 5.7 6 15.3 0 21l-19.199 19.501zm49.501-94.499h-140.7l-55.8 111.599c-2.1 4.5-6.301 7.5-11.1 8.101-3.037 1.012-9.225-.115-12.9-4.201l-30-30c-6-5.7-6-15.3 0-21 5.7-5.999 15.298-5.999 20.999 0l15.3 15.3 50.7-101.4c2.701-5.099 7.8-8.399 13.5-8.399h150c8.401 0 15 6.599 15 15 .001 8.399-6.598 15-14.999 15zm2.701 271h-30.3l12.9 77.398c1.617 10.109 11.922 14.027 17.1 12.301 8.099-1.199 13.799-9 12.299-17.1zm-257.401 72.599c-1.5 8.101 4.2 15.901 12.299 17.1 5.143 1.714 15.483-2.189 17.1-12.301l12.9-77.398h-30.3z",
    fill: "url(#SVGID_2_)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathematics);
export default __webpack_public_path__ + "static/media/mathematics.be37b1e006ed265d7d1dad94a5e8410a.svg";
export { ForwardRef as ReactComponent };